/**
 * @flow
 * @relayHash 2e3d3f6fe44f786e2dce5a460836dc1d
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type BookingStatus = "BOOKED" | "CANCELED" | "INITIAL" | "%future added value";
export type CreatePlistEventInput = {
  clientMutationId?: ?string,
  plist_id: string,
  event_id: string,
  position?: ?number,
};
export type PipelinesComponent_createPlistEventMutationVariables = {|
  input: CreatePlistEventInput
|};
export type PipelinesComponent_createPlistEventMutationResponse = {|
  +createPlistEvent: ?{|
    +new_plist_event_edge: ?{|
      +node: ?{|
        +id: string,
        +position: ?number,
        +event: ?{|
          +id: string,
          +user_event: ?{|
            +booking_status: ?BookingStatus,
            +start_at: ?any,
            +end_at: ?any,
            +user_event_segments: ?{|
              +edges: ?$ReadOnlyArray<?{|
                +node: ?{|
                  +location: ?string,
                  +room: ?string,
                |}
              |}>
            |},
            +event: ?{|
              +id: string,
              +title: ?string,
              +start_at: ?any,
              +end_at: ?any,
            |},
          |},
        |},
      |}
    |}
  |}
|};
export type PipelinesComponent_createPlistEventMutation = {|
  variables: PipelinesComponent_createPlistEventMutationVariables,
  response: PipelinesComponent_createPlistEventMutationResponse,
|};
*/


/*
mutation PipelinesComponent_createPlistEventMutation(
  $input: CreatePlistEventInput!
) {
  createPlistEvent(input: $input) {
    new_plist_event_edge {
      node {
        id
        position
        event {
          id
          user_event {
            booking_status
            start_at
            end_at
            user_event_segments(first: 99999) {
              edges {
                node {
                  location
                  room
                  id
                }
              }
            }
            event {
              id
              title
              start_at
              end_at
            }
            id
          }
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreatePlistEventInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "CreatePlistEventInput!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "position",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "booking_status",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "start_at",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "end_at",
  "args": null,
  "storageKey": null
},
v7 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }
],
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "location",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "room",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "event",
  "storageKey": null,
  "args": null,
  "concreteType": "Event",
  "plural": false,
  "selections": [
    v2,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    v5,
    v6
  ]
};
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "PipelinesComponent_createPlistEventMutation",
  "id": null,
  "text": "mutation PipelinesComponent_createPlistEventMutation(\n  $input: CreatePlistEventInput!\n) {\n  createPlistEvent(input: $input) {\n    new_plist_event_edge {\n      node {\n        id\n        position\n        event {\n          id\n          user_event {\n            booking_status\n            start_at\n            end_at\n            user_event_segments(first: 99999) {\n              edges {\n                node {\n                  location\n                  room\n                  id\n                }\n              }\n            }\n            event {\n              id\n              title\n              start_at\n              end_at\n            }\n            id\n          }\n        }\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "PipelinesComponent_createPlistEventMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "createPlistEvent",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreatePlistEventPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "new_plist_event_edge",
            "storageKey": null,
            "args": null,
            "concreteType": "PlistEventEdge",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "PlistEvent",
                "plural": false,
                "selections": [
                  v2,
                  v3,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "event",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Event",
                    "plural": false,
                    "selections": [
                      v2,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "user_event",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserEvent",
                        "plural": false,
                        "selections": [
                          v4,
                          v5,
                          v6,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "user_event_segments",
                            "storageKey": "user_event_segments(first:99999)",
                            "args": v7,
                            "concreteType": "UserEventSegmentConnection",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "edges",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "UserEventSegmentEdge",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "node",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "UserEventSegment",
                                    "plural": false,
                                    "selections": [
                                      v8,
                                      v9
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          v10
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "PipelinesComponent_createPlistEventMutation",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "createPlistEvent",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreatePlistEventPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "new_plist_event_edge",
            "storageKey": null,
            "args": null,
            "concreteType": "PlistEventEdge",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "PlistEvent",
                "plural": false,
                "selections": [
                  v2,
                  v3,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "event",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Event",
                    "plural": false,
                    "selections": [
                      v2,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "user_event",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserEvent",
                        "plural": false,
                        "selections": [
                          v4,
                          v5,
                          v6,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "user_event_segments",
                            "storageKey": "user_event_segments(first:99999)",
                            "args": v7,
                            "concreteType": "UserEventSegmentConnection",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "edges",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "UserEventSegmentEdge",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "node",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "UserEventSegment",
                                    "plural": false,
                                    "selections": [
                                      v8,
                                      v9,
                                      v2
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          v10,
                          v2
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '0930b289209e9ce0a70019ae89eb778c';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Event/Pipelines/__generated__/PipelinesComponent_createPlistEventMutation.graphql.js